import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';

export const redirectTopLocation = (exitPath: string): void => {
    if (window.top) {
        window.top.location.href = handleLocaleUrl(exitPath, GLOBAL_CLIENT_ONLY_LOCALE);
    }
};
